import { LuxonZone } from 'types/LuxonZone';
import useTimeRangePopulator from './useTimeRangePopulator';
import useWeeklyTimeRangeGet from './useWeeklyTimeRangeGet';

export default function useWeeklyPopulator(zone: LuxonZone) {
  const getter = useWeeklyTimeRangeGet(zone);
  return useTimeRangePopulator(getter);
}
